import { render, staticRenderFns } from "./DiariesV2.vue?vue&type=template&id=2dc03f2f"
import script from "./DiariesV2.vue?vue&type=script&lang=js"
export * from "./DiariesV2.vue?vue&type=script&lang=js"
import style0 from "./DiariesV2.vue?vue&type=style&index=0&id=2dc03f2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports